/* ==========================================================================
   ORKA — inline video cards
   --------------------------------------------------------------------------
   Click the poster to play with sound and loop; click again to pause.
   Only one video plays anywhere on the page at a time — starting one pauses
   whichever was running.

   Markup contract:
     <div class="orka-video" data-orka-video>
       <video ...></video>
       <button data-orka-video-toggle>…</button>
     </div>
   ========================================================================== */

(function () {
  'use strict';

  var PLAYING = 'is-playing';
  var current = null;

  function pause(card) {
    if (!card) return;
    var video = card.querySelector('video');
    if (video) video.pause();
    card.classList.remove(PLAYING);
    var btn = card.querySelector('[data-orka-video-toggle]');
    if (btn) btn.setAttribute('aria-label', btn.dataset.labelPlay || 'Play video');
    if (current === card) current = null;
  }

  function play(card) {
    var video = card.querySelector('video');
    if (!video) return;

    // Starting a video stops the one already running.
    if (current && current !== card) pause(current);

    video.loop = true;
    video.muted = false;
    video.volume = 1;

    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {
        // Some browsers refuse unmuted playback without a stronger gesture —
        // fall back to muted rather than leaving the user with nothing.
        video.muted = true;
        video.play().catch(function () {});
      });
    }

    card.classList.add(PLAYING);
    var btn = card.querySelector('[data-orka-video-toggle]');
    if (btn) btn.setAttribute('aria-label', btn.dataset.labelPause || 'Pause video');
    current = card;
  }

  function toggle(card) {
    var video = card.querySelector('video');
    if (!video) return;
    if (video.paused) {
      play(card);
    } else {
      pause(card);
    }
  }

  function initCard(card) {
    if (card.dataset.orkaVideoReady === 'true') return;
    card.dataset.orkaVideoReady = 'true';

    var video = card.querySelector('video');
    if (video) {
      video.removeAttribute('controls');
      video.setAttribute('playsinline', '');
      video.addEventListener('ended', function () { pause(card); });
      video.addEventListener('pause', function () { card.classList.remove(PLAYING); });
    }

    card.addEventListener('click', function (evt) {
      // Let real links inside the card behave normally.
      if (evt.target.closest('a')) return;
      evt.preventDefault();
      toggle(card);
    });

    card.addEventListener('keydown', function (evt) {
      if (evt.key === ' ' || evt.key === 'Enter') {
        evt.preventDefault();
        toggle(card);
      }
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-orka-video]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (evt) { initAll(evt.target); });
  document.addEventListener('shopify:section:unload', function () { current = null; });

  window.OrkaVideo = { init: initAll, pauseAll: function () { pause(current); } };
})();
